import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';

var BorderPosition;
(function (BorderPosition) {
    BorderPosition["top"] = "top";
    BorderPosition["bottom"] = "bottom";
})(BorderPosition || (BorderPosition = {}));
/**
 * Providence Title component.
 * @see {@link https://providence.fmr.com/4.x/components/title/title.html|Title documentation}
 */
class PvdTitle extends PvdSlotifyBaseComponent {
    // #endregion
    // #region LitElement lifecycles
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-title-root`,
            modifierPrefix: 'pvd-title',
            modifiers: [
                {
                    condition: this.pvdBorder !== undefined,
                    className: `border-${this.pvdBorder}`,
                },
                {
                    condition: this.isSlotUsed('metadata'),
                    className: 'metadata',
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}"><div class="pvd-title__title"><div class="pvd-title__heading-wrapper"><s-slot name="heading"></s-slot>${this.isSlotUsed('metadata')
            ? x `<span class="pvd-title__metadata-wrapper"><s-slot name="metadata"></s-slot></span>`
            : x `<s-slot name="metadata"></s-slot>`} ${this.isSlotUsed('annotation')
            ? x `<sup class="pvd-title__annotation-wrapper"><s-slot name="annotation"></s-slot></sup>`
            : x `<s-slot name="annotation"></s-slot>`} ${this.isSlotUsed('subheading')
            ? x `<div class="pvd-title__subheading-wrapper"><s-slot name="subheading"></s-slot></div>`
            : x `<s-slot name="subheading"></s-slot>`}</div>${this.isSlotUsed('action')
            ? x `<div class="pvd-title__action-wrapper"><s-slot name="action"></s-slot></div>`
            : x `<s-slot name="action"></s-slot>`}</div></div>`;
    }
}
//#region Component configuration
PvdTitle.componentName = 'title';
__decorate([
    n({
        type: String,
        reflect: true,
        attribute: 'pvd-border',
        ...PvdSlotifyBaseComponent.hasChanged(BorderPosition),
    }),
    __metadata("design:type", String)
], PvdTitle.prototype, "pvdBorder", void 0);

export { BorderPosition, PvdTitle };
//# sourceMappingURL=pvd-title.js.map
